<template>
  <v-container fluid pa-0>
    <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">
      Organization Users ({{ users.length }})
    </v-flex>
    <v-card class="elevation-0" secondary style="padding: 60px; flex: none; margin-top: 60px">
      <v-flex style="display: flex; align-items: center; cursor: pointer" @click="inviteUsersDialog = true">
        <v-btn :ripple="false" large style="height: 73px; width: 73px; font-size: 28px; margin: 0" fab class="elevation-0 addBtn" outline color="primary highlight--text">+</v-btn>
        <div style="font-size: 18px; font-weight: 700; padding-left: 10px" class="primary--text">Add new user</div>
      </v-flex>
      <div xs12 style="font-size: 24px; font-weight: 700; margin-top: 60px" class="primary--text">Administrators <span style="font-weight: 300">{{ administrators.length }}</span></div>
      <v-layout row wrap style="margin-top: 30px">
        <v-flex style="flex: none; display: flex; align-items: center; margin-right: 30px; margin-bottom: 30px;flex-grow: 1;flex-basis: 0;" v-for="item in administrators" :key="item.id">
          <img style="max-width: 73px" src="@/assets/user.png" />
          <div style="padding-left: 10px; height: 100%; display: flex; align-items: center">
            <v-flex v-if="item.firstName && item.firstName !== ''" class="primary--text" style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px">{{item.firstName + ' ' + item.lastName}}</v-flex>
            <v-flex v-else class="primary--text" style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px">{{item.email}}</v-flex>
          </div>
          <v-btn small icon v-if="item.id !== currentUser.id && item.defaultRoleId !== masterRoleId && item.id !== userOrganization.ownerUserId" :ripple="false" light @click="removeSelectedUser(item.id)" style="text-align: right; position: relative; padding: 0px; margin: 0px; margin-left: 15px;">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <div xs12 style="font-size: 24px; font-weight: 700; margin-top: 60px" class="primary--text">Viewers <span style="font-weight: 300">{{ viewers.length }}</span></div>
      <v-layout row wrap style="margin-top: 30px">
        <v-flex style="flex: none; display: flex; align-items: center; margin-right: 30px; margin-bottom: 30px;flex-grow: 1;flex-basis: 0;" v-for="item in viewers" :key="item.id">
          <img style="max-width: 73px" src="@/assets/user.png" />
          <div style="padding-left: 10px; height: 100%; display: flex; align-items: center">
            <v-flex class="primary--text" v-if="item.firstName !== ''" style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px">{{item.firstName + ' ' + item.lastName}}</v-flex>
            <v-flex class="primary--text" v-else style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px">{{item.email}}</v-flex>
          </div>
          <v-btn small icon :ripple="false" light @click="removeSelectedUser(item.id)" style="text-align: right; position: relative; padding: 0px; margin: 0px; margin-left: 15px;">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="inviteUsersDialog" fullscreen transition="dialog-transition">
      <v-card>
        <v-card-text>
          <v-flex xs12 class="secondary" style="padding: 60px">
            <v-flex style="position: relative; width: 100%; height: 100%;">
              <v-btn small icon light @click="inviteUsersDialog = false" style="text-align: right; position: absolute; top: -23px; right: -23px; padding: 0; margin: 0">
                <v-icon>close</v-icon>
              </v-btn>
              <div v-if="inviteUsersDialog" style="display: flex; align-items: center; justify-content: center">
                <OrganizationInviteUsersForm v-bind:options="{}"></OrganizationInviteUsersForm>
              </div>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  .addBtn .v-btn__content{
    font-size: 36px !important
  }
</style>

<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'
import OrganizationInviteUsersForm from '../organization/OrganizationInviteUsersForm.vue'

export default {
  data: () => ({
    rowsPerPageItems: [12, 16, 20],
    pagination: { rowsPerPage: 12 },
    inviteUsersDialog: false,
    loadingState: 'noData',
    users: []
  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      userOrganization: 'getUserOrganization'
    }),
    administrators () {
      return this.userOrganization.users.filter(user => {
        return this.userOrganization.organizationUsers.filter(e => Number(e.userId) === Number(user.id) && (Number(e.roleId) === Number(this.adminRoleId) || Number(e.roleId) === Number(this.masterRoleId))).length > 0
      })
    },
    viewers () {
      return this.userOrganization.users.filter(user => {
        return this.userOrganization.organizationUsers.filter(e => (Number(e.roleId) === Number(this.viewerRoleId) && Number(e.userId) === Number(user.id))).length > 0
      })
    },
    masterRoleId () {
      return this.$store.getters['getRoleByName']('MASTER_ROLE').id
    },
    adminRoleId () {
      return this.$store.getters['getRoleByName']('ADMIN_ROLE').id
    },
    viewerRoleId () {
      return this.$store.getters['getRoleByName']('VIEWER_ROLE').id
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getData: function () {
      this.loadingState = 'loading'
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.userOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
          this.loadingState = 'none'
        } else {
          this.loadingState = 'none'
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loadingState = 'none'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    removeSelectedUser (id) {
      this.loadingState = 'loading'
      axios.all([this.$store.dispatch('deleteOrganizationUserByOrganizationIdAndUserId', {organizationId: this.userOrganization.id, userId: id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.getData()
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loadingState = 'error'
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loadingState = 'error'
        console.log(err)
      })
    }
  },
  mounted: function () {
    if (!this.isLoggedIn) {
      this.$router.push({ path: '/login' })
    }
    this.users = this.userOrganization.users
  },
  components: {
    OrganizationInviteUsersForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/OrganizationUsers.vue